import React from 'react';
import { FiRefreshCw } from 'react-icons/fi';
import { IconType } from 'react-icons';

interface DashboardHeaderProps {
  onRefresh: () => void;
  disabled: boolean;
  isRefreshing: boolean;
  actionsSlot?: React.ReactNode;
}

const renderIcon = (Icon: IconType, className: string) => {
  const IconComponent = Icon as React.ComponentType<{ className?: string }>;
  return <IconComponent className={className} />;
};

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  onRefresh,
  disabled,
  isRefreshing,
  actionsSlot,
}) => (
  <div className="mb-8 flex items-center justify-between">
    <h1 className="text-3xl lg:text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 dark:from-slate-200 dark:to-slate-400 bg-clip-text text-transparent mb-2">
      Dashboard
    </h1>
    <div className="flex items-center gap-2">
      {actionsSlot}
      <button
        type="button"
        onClick={onRefresh}
        disabled={disabled}
        className="flex items-center gap-2 px-4 py-2 text-sm font-semibold text-gray-800 dark:text-white bg-gray-200 dark:bg-gray-700 rounded-xl hover:bg-gray-300 dark:hover:bg-gray-600 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl hover:scale-105 transform disabled:hover:scale-100"
      >
        {renderIcon(FiRefreshCw as IconType, `w-4 h-4 ${isRefreshing ? 'animate-spin' : ''}`)}
        <span>Yenile</span>
      </button>
    </div>
  </div>
);
